module.exports = __webpack_public_path__ + "static/media/hi-IN.d61d2eeb.md";